<div
  cdkDrag
  class="market-data-drag"
  (cdkDragEnded)="dragEnd()"
  cdkDragBoundary="html"
  minWidth="640"
  [ngStyle]="{ 'top.px': windowTop, 'left.px': windowLeft }"
>
  <div class="market-data-container-content">
    <div class="menu-bar" cdkDragHandle (mousedown)="updateZIndex()">
      <div class="market-data-container-content__menu-bar__title">
        Market Data Updates
      </div>
      <button class="button-close" (click)="close()"></button>
    </div>

    <div class="market-data-container-content__main">
      @if (messages.length === 0) {
        <h4>No market data</h4>
      } @else {
        <table ui-table>
          <thead>
            <tr>
              <th class="col-alert"></th>
              <th class="col-parent">Check</th>
              <th class="col-feedupdate">Last feed update</th>
              <th class="col-feedupdate">Max age (mins)</th>
              <th class="col-lastrefresh">Last refresh</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let m of messages">
              <td
                class="traffic-lights col-alert"
                style="--intensity: {{ m.alertLevel }}"
              >
                <cds-icon shape="circle" solid></cds-icon>
              </td>
              <td class="col-parent">{{ m.label }}</td>
              <td class="col-feedupdate">
                <span *ngIf="m.dynamicDiff">{{ m.ago }} ago</span>
              </td>
              <td class="col-ages">
                <span class="traffic-lights" style="--intensity: 0.5">
                  <cds-icon shape="circle" solid size="10"></cds-icon>
                </span>
                <span>{{ toMins(m.max_age_lo) }}&nbsp;/&nbsp;</span>
                <span class="traffic-lights" style="--intensity: 1">
                  <cds-icon shape="circle" solid size="10"></cds-icon>
                </span>
                {{ toMins(m.max_age_hi) }}
              </td>
              <td class="col-lastrefresh">
                <span class="time-since-update">{{
                  m.timeSinceupdateStr
                }}</span>
                ago
              </td>
            </tr>
          </tbody>
        </table>
      }
    </div>
  </div>
</div>
